<h1 class="pageTitle" id="skipLinkTarget" tabIndex="0" *ngIf="true" [innerHTML]="pageTitleService.getPageTitle()"></h1>